import classNames from 'classnames';
import { Outlet } from 'react-router-dom';
import LoadingSpinner from '../loading-spinner/loading-spinner';

export interface AdminContentProps {
  transitionDurationClass: string;
  contentWidth?: number;
  contentHeight?: number;
}

export function AdminContent({
  transitionDurationClass,
  contentWidth,
  contentHeight,
}: AdminContentProps) {
  if (!contentHeight || !contentWidth) {
    return <LoadingSpinner makeAbsolute spinnerId='admin-content-loading' />;
  }

  return (
    <div
      style={{ height: contentHeight, width: contentWidth }}
      className={classNames(
        'p-7 overflow-auto transition-width shadow-inner bg-gray-100',
        transitionDurationClass
      )}
    >
      <Outlet />
    </div>
  );
}

export default AdminContent;
